export default function PreviewBanner() {
  return (
    <div className="bg-yellow-300 text-black p-2 text-center">
      👀 Esikatselu (draft)
    </div>
  );
}
